<div class="page admin js-page">
  <app-dispatcher-side-nav class="hidden-print sidenav" (onComponentSelected)="select($event)"></app-dispatcher-side-nav>
  <div class="adminpanel">
    <div class="adminobjects" id="dispatcher_table" *ngIf="isSelected('dispatcher_table')" app-dispatcher-table></div>
    <div class="adminobjects" id="dispatcher_report" *ngIf="isSelected('dispatcher_report')" app-dispatcher-report></div>
    <div class="adminobjects" id="storage_tank" *ngIf="isSelected('storage_tank')" app-storage-tank></div>
  </div>
</div>
